import type { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren<unknown> {
  tabGroupId: string;
  activeTab: string;
  className?: string;
  'data-testid'?: string;
}

export const ContentSwitcherTabPanel: React.FC<Props> = ({
  tabGroupId,
  activeTab,
  className,
  children,
  'data-testid': dataTestId,
}) => (
  <main
    className={className}
    data-testid={dataTestId}
    role="tabpanel"
    id={`${tabGroupId}-tabpanel`}
    aria-labelledby={`${tabGroupId}-tab-${activeTab}`}
  >
    {children}
  </main>
);
